exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Index[data-v-82b7485c] {\n  display: flex;\n  max-height: calc(100vh - 48px);\n  width: 100%;\n}\n", ""]);

// exports
